import { ProjectItem } from '../../queries/fragments/project';
import { WholeState } from './type';

export function isLoadingProjectsCarousel(state: WholeState): boolean {
  return state.search !== undefined
    ? state.search.loadingProjectsCarousel
    : false;
}

export function getProjectsTotalCount(state: WholeState): number {
  return state.search !== undefined ? state.search.projectsTotalCount : 0;
}

export function getProjectItems(state: WholeState): ProjectItem[] {
  return state.search !== undefined ? state.search.projectsItems : [];
}
